import * as z from 'zod'

import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'

import {COLUMN_COUNT, PricingTableRowSchema} from './pricing-table-row'
import {PricingTableColumnSchema} from './pricing-table-column'

const COMPONENT_ID = 'pricingTable'

export const PricingTableSchema = buildEntrySchemaFor(COMPONENT_ID, {
  fields: z.lazy(() =>
    z.object({
      title: z.string().optional(),
      columns: z.array(z.lazy(() => PricingTableColumnSchema)).length(COLUMN_COUNT),
      rows: z.array(z.lazy(() => PricingTableRowSchema)),
    }),
  ),
})

export type PricingTable = z.infer<typeof PricingTableSchema>
